module.exports = __webpack_public_path__ + "img/horizontal_bar_chart.cd9b27b1.svg";